(function ($) {


  const Init = (() => {

    let website = {},
      load = {},
      resize = {},
      resizeW = {},
      scroll = {},
      orientation = {},
      mod = {},
      anime = {},
      scrollOption = {},
      parallax = {},
      drawer = {},
      wp = {},
      slider = {},
      map = {},
      ajax = {},
      top = {},
      basic = {};

    website = {
      page: document.body.dataset.page,
      url: document.URL,
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
      scrollY: window.pageYOffset,
      scrollCurrent: 0,
      breakpoint: { pc: 1200, tb: 992, sp: 768, ss: 576 },
      ua: navigator.userAgent.toLowerCase(),
      isDesktop: true,
      isMobile: false,
      isFirst: true,
      animationFrame: null,

      headTag: document.getElementById('js-header'),
      footTag: document.getElementById('js-footer'),
      // headTag       : $('#js-header'),
      // footTag       : $('#js-footer'),
      adminId: 'wpwrap',

      act: 'is-act',
      actView: 'is-view',
      actOpen: 'is-open',
      loaded: 'is-loaded',

      targetAnime: 'js-anime',
      actAnime: 'is-anime',
      shiftPoint: 0,
      shiftPc: 5,
      shiftSp: 10,
    };
    website.shiftPoint = website.breakpoint.tb;

    if (document.getElementById(website.adminId) != null) {
      website.page = 'admin';
    }

    load = {
      functions: [],
      length: 0,
    };

    resize = {
      functions: [],
      length: 0,
      // fps      : 60,
      isRunning: false,
      animationFrame: null,
    };
    resizeW = {
      functions: [],
      length: 0,
      // fps      : 60,
      isRunning: false,
      animationFrame: null,
    };

    scroll = {
      functions: [],
      length: 0,
      // fps      : 60,
      isRunning: false,
      animationFrame: null,
    };

    orientation = {
      functions: [],
      length: 0,
      // fps      : 60,
      isRunning: false,
      animationFrame: null,
    };




    




    const WinLoad = {




    




      init() {




        window.addEventListener('load', function(e) {




          WinLoad.update();




        });




    




        console.log('!-- load init --!');




      },




    




      add(func) {




        load.functions.push(func);




        load.length = load.functions.length;




      },




    




      remove(func) {




        load.functions.splice(func, 1);




        load.length = load.functions.length;




      },




    




      update() {




        for ( let i = 0; i < load.length; i++ ) {




          let func = load.functions[i];




          func();




        }




      },




    




    }




    




    




    const WinResize = {




    




      init() {




        window.addEventListener('resize', function(e) {




          if ( !resize.isRunning ) {




            resize.isRunning = true;




    




            resize.animationFrame = window.requestAnimationFrame( WinResize.update );




    




            // if ( window.requestAnimationFrame ) {




            //   window.requestAnimationFrame(() => {




            //     WinResize.update();




            //   });




            // } else {




            //   setTimeout(() => {




            //     WinResize.update();




            //   }, 1000/resize.fps);




            // }




          }




        });




    




        console.log('!-- resize init --!');




      },




    




      add(func) {




        resize.functions.push(func);




        resize.length = resize.functions.length;




      },




    




      remove(func) {




        resize.functions.splice(func, 1);




        resize.length = resize.functions.length;




      },




    




      update() {




        website.winWidth  = window.innerWidth;




        website.winHeight = window.innerHeight;




        website.ua        = navigator.userAgent.toLowerCase();




    




        for ( let i = 0; i < resize.length; i++ ) {




          let func = resize.functions[i];




          func();




        }




    




        resize.isRunning = false;




      },




    




    }




    




    




    const WinResizeWidth = {




    




      init() {




        window.addEventListener('resize', function(e) {




          if ( website.winWidth != window.innerWidth && !resizeW.isRunning ) {




            resizeW.isRunning = true;




            resizeW.animationFrame = window.requestAnimationFrame( WinResizeWidth.update );




          }




        });




    




        console.log('!-- resizeW init --!');




      },




    




      add(func) {




        resizeW.functions.push(func);




        resizeW.length = resizeW.functions.length;




      },




    




      remove(func) {




        resizeW.functions.splice(func, 1);




        resizeW.length = resizeW.functions.length;




      },




    




      update() {




        for ( let i = 0; i < resizeW.length; i++ ) {




          let func = resizeW.functions[i];




          func();




        }




    




        resizeW.isRunning = false;




      },




    




    }




    




    




    const WinScroll = {




    




      init() {




        window.addEventListener('scroll', function(e) {




          if ( !scroll.isRunning ) {




            scroll.isRunning = true;




    




            scroll.animationFrame = window.requestAnimationFrame( WinScroll.update );




    




            // if ( window.requestAnimationFrame ) {




            //   window.requestAnimationFrame(() => {




            //     WinScroll.update();




            //   });




            // } else {




            //   setTimeout(() => {




            //     WinScroll.update();




            //   }, 1000/scroll.fps);




            // }




          }




        });




    




        console.log('!-- scroll init --!');




      },




    




      add(func) {




        scroll.functions.push(func);




        scroll.length = scroll.functions.length;




      },




    




      remove(func) {




        scroll.functions.splice(func, 1);




        scroll.length = scroll.functions.length;




      },




    




      update() {




        website.winHeight = window.innerHeight;




        website.scrollY   = window.pageYOffset;




    




        for ( let i = 0; i < scroll.length; i++ ) {




          let func = scroll.functions[i];




          func();




        }




    




        scroll.isRunning = false;




      },




    




    }




    




    




    const OrientationChange = {




    




      init() {




        window.addEventListener('orientationchange', function(e) {




          if ( !orientation.isRunning ) {




            orientation.isRunning = true;




    




            orientation.animationFrame = window.requestAnimationFrame( OrientationChange.update );




          }




        });




    




        console.log('!-- orientationchange init --!');




      },




    




      add(func) {




        orientation.functions.push(func);




        orientation.length = orientation.functions.length;




      },




    




      remove(func) {




        orientation.functions.splice(func, 1);




        orientation.length = orientation.functions.length;




      },




    




      update() {




        for ( let i = 0; i < orientation.length; i++ ) {




          let func = orientation.functions[i];




          func();




        }




    




        orientation.isRunning = false;




      },




    




    }




    

    

    const Modules = {

    

      init() {

        mod = {

          targetSmooth: 'js-scroll',

          smoothSpeed: 600,

    

          targetTab: 'js-tabWrap',

    

          targetAccordion: 'js-accordion',

          targetAccordionSp: 'js-accordionSp',

          targetAccordionPrev: 'js-accordionPrev',

          targetAccordionPrevTfoot: 'js-accordionPrevTfoot',

    

          targetModalOpen: 'js-modal',

          targetModalClose: 'js-modalClose',

          targetModalOverlay: 'js-modalOverlay',

          actBodyModal: 'is-modal',

    

          // targetCursor   : 'js-cursor',

          // targetCursorSub: 'js-cursorSub',

    

          // targetAlign     : 'js-align',

          // targetAlignList : [],

          // alignAddClass   : 'u-align_height',

    

          targetDate: 'js-date',

          targetDateClear: 'js-dateClear',

          targetDateFuture: 'js-dateFuture',

    

          targetDisplay: 'js-display',

    

          targetConfirm: 'js-confirm',

    

          targetFormSubmit: 'js-submit',

          targetFormBlank: 'js-submitBlank',

    

    

          targetSort: 'js-sortList',

          targetSortName: 'js-sortName',

    

    

          targetOfi: 'js-ofi',

        };

    

        // let alignList = document.querySelectorAll('.' + mod.targetAlign);

        // mod.targetAlignList = Array.prototype.slice.call(alignList, 0);

    

        this.iosCheck();

        this.deviceCheck();

        this.smoothScroll();

        this.tabBtn();

        this.accordionBtn();

        this.modalBtn();

        this.displayToggle();

        this.confirmBtn();

        this.formSubmit();

    

    

        if (website.page == 'admin') {

          this.dateCalendar();

          this.sortList();

        }

    

        objectFitImages('.' + mod.targetOfi);

    

        // 一時的

        // $('a[href="#"]:not(".js-accordionSp")').each(function () {

        //   $(this).css('pointer-events', 'none');

        // });

      },

    

      viewportHeight() {

        let vh = website.winHeight * 0.01;

        document.documentElement.style.setProperty('--vh', `${vh}px`);

      },

    

      iosCheck() {

        if (website.ua.indexOf('ipad') > -1 || website.ua.indexOf('iphone') > -1 || (website.ua.indexOf('macintosh') > -1 && 'ontouchend' in document)) {

          $('body').addClass('is-ios');

        } else {

          $('body').removeClass('is-ios');

        }

      },

    

      deviceCheck() {

        if (

          website.ua.indexOf('iphone') > -1 ||

          website.ua.indexOf('ipod') > -1 ||

          website.ua.indexOf('android') > -1 && website.ua.indexOf('mobile') > -1

        ) {

          website.isDesktop = false;

          website.isMobile = true;

          $('body').removeClass('is-pc is-tb').addClass('is-sp');

        } else if (

          website.ua.indexOf('ipad') > -1 ||

          website.ua.indexOf('Android') > -1 ||

          (website.ua.indexOf('macintosh') > -1 && 'ontouchend' in document)

        ) {

          website.isDesktop = false;

          website.isMobile = false;

          $('body').removeClass('is-pc is-sp').addClass('is-tb');

        } else {

          website.isDesktop = true;

          website.isMobile = false;

          $('body').removeClass('is-tb is-sp').addClass('is-pc');

        }

      },

    

      smoothScroll() {

        $('.' + mod.targetSmooth + ':not([href=""])').on('click', function () {

          let href = $(this).attr("href"),

            target = $((href == "#") ? 'html' : href),

            shift = (($(this).data('scroll') == 'shift') && (href != "#")) ? website.headTag.offsetHeight : 0,

            position = target.offset().top - shift;

    

          $('body,html').animate({ scrollTop: position }, mod.smoothSpeed, 'swing');

          return false;

        });

      },

    

      tabBtn() {

        $('.' + mod.targetTab).each(function () {

          let tabObj = $('> li > a', this),

            contId = ($(this).data('tab')) ? $(this).data('tab') : '',

            contsObj = (contId) ? $(contId).children('div') : $(this).next().children('div');

    

          tabObj.on('click', function () {

            let tabHref = $(this).attr('href');

    

            tabObj.removeClass(website.act);

            $(this).addClass(website.act);

    

            $(contId).css('min-height', $(contId).height() + 'px');

            contsObj.hide();

            $(tabHref).fadeIn();

            $(contId).css('min-height', 'auto');

    

            return false;

          });

        });

      },

    

      accordionBtn() {

        $('.' + mod.targetAccordion).on('click', function () {

          if ($(this).hasClass(website.act)) {

            $(this).removeClass(website.act).next().stop().slideUp('fast');

            // $(this).removeClass(website.act);

          } else {

            $(this).addClass(website.act).next().stop().slideDown();

            // $(this).addClass(website.act);

          }

        });

    

        $('.' + mod.targetAccordionSp).on('click', function () {

          if (website.winWidth < website.shiftPoint) {

            if ($(this).hasClass(website.act)) {

              $(this).removeClass(website.act).next().stop().slideUp('fast');

              // $(this).removeClass(website.act);

            } else {

              $(this).addClass(website.act).next().stop().slideDown();

              // $(this).addClass(website.act);

            }

            return false;

          }

        });

    

        $('.' + mod.targetAccordionPrev).on('click', function () {

          if ($(this).hasClass(website.act)) {

            $(this).removeClass(website.act).prev().stop().slideUp('fast');

          } else {

            $(this).addClass(website.act).prev().stop().slideDown();

          }

        });

    

        $('.' + mod.targetAccordionPrevTfoot).on('click', function () {

          if ($(this).hasClass(website.act)) {

            $(this).removeClass(website.act).prev().find('tfoot').hide();

          } else {

            $(this).addClass(website.act).prev().find('tfoot').show();

          }

        });

      },

    

      modalBtn() {

        $(document).on('click', '.' + mod.targetModalOpen, function (e) {

          let href = $(this).attr("href");

          $('body').addClass(mod.actBodyModal);

          $(href).addClass(website.actOpen).parent().addClass(website.act);

          return false;

        });

    

        $('.' + mod.targetModalClose).each(function () {

          $(this).on('click', function () {

            $('body').removeClass(mod.actBodyModal);

            $(this).closest('.' + website.actOpen).removeClass(website.actOpen).parent().removeClass(website.act);

          });

        });

    

        $(document).on('click', '.' + mod.targetModalOverlay, function () {

          $('body').removeClass(mod.actBodyModal);

          $(this).nextAll('.' + website.actOpen).removeClass(website.actOpen).parent().removeClass(website.act);

        });

      },

    

      // cursor() {

      //   let cursor    = document.getElementById(mod.targetCursor),

      //       cursorSub = document.getElementById(mod.targetCursorSub);

    

      //   document.addEventListener('mousemove', function (e) {

      //     cursor.style.transform    = 'translate(' + e.clientX + 'px, ' + e.clientY + 'px)';

      //     cursorSub.style.transform = 'translate(' + e.clientX + 'px, ' + e.clientY + 'px)';

      //   });

    

    

      //   let linkElem = document.querySelectorAll('a, button');

      //   for (let i = 0; i < linkElem.length; i++) {

      //     linkElem[i].addEventListener('mouseover', function (e) {

      //       // cursor.classList.add(website.act);

      //       cursorSub.classList.add(website.act);

      //     });

      //     linkElem[i].addEventListener('mouseout', function (e) {

      //       // cursor.classList.remove(website.act);

      //       cursorSub.classList.remove(website.act);

      //     });

      //   }

      // },

    

      // alignHeight() {

      //   let alignHeight  = 0;

    

      //   mod.targetAlignList.forEach((target) => {

      //     target.style.minHeight = 'auto';

      //     target.classList.add(mod.alignAddClass);

      //     alignHeight = ( target.offsetHeight > alignHeight ) ? target.offsetHeight: alignHeight;

      //     target.classList.remove(mod.alignAddClass);

      //   });

      //   mod.targetAlignList.forEach((target) => {

      //     target.style.minHeight = alignHeight + 'px';

      //   });

      // },

    

      displayToggle() {

        $('.' + mod.targetDisplay).each(function () {

          let targetName = $(this).data('display'),

            targetTag = $(targetName),

            disabled = $(this).data('disabled');

    

          if (this.tagName == 'INPUT' || this.tagName == 'SELECT') {

            $(this).on('change', function () {

              if (

                (this.tagName == 'INPUT' && this.checked) ||

                (this.tagName == 'SELECT' && this.value - 0)

              ) {

                targetTag.fadeIn();

                if (disabled == true) {

                  targetTag.children('input[type="hidden"]').prop('disabled', false);

                }

              } else {

                targetTag.fadeOut();

                if (disabled == true) {

                  targetTag.children('input[type="hidden"]').prop('disabled', true);

                }

              }

            }).change();

          } else {

            $(this).on('click', function () {

              $(this).remove();

              targetTag.fadeIn();

            });

          }

        });

      },

    

      confirmBtn() {

        $('.' + mod.targetConfirm).each(function () {

          let link = $(this).data('link'),

            text = ($(this).data('text')) ? $(this).data('text') : '【重要】 削除を実行しようとしています。\nこの操作は取り消すことができません。\n本当に実行しますか？';

    

          $(this).on('click', function () {

            var checked = confirm(text);

            if (checked === true) {

              location.href = link;

              return false;

            }

          });

        });

      },

    

    

      formSubmit() {

        $(document).on('submit', 'form', function (e) {

          if (

            e.originalEvent != undefined &&

            $(e.originalEvent.submitter).hasClass(mod.targetFormSubmit)

          ) {

            $('button[type="submit"]').each(function () {

              $(this).css('pointer-events', 'none');

            });

          }

        });

    

        $('.' + mod.targetFormBlank).on('click', function (e) {

          e.preventDefault();

          let targetForm = $(this).closest('form'),

            defaultVal = targetForm.prop('action'),

            changeVal = ($(this).data('action')),

            blank = $(this).data('blank');

          if (blank == false) {

            targetForm.prop('action', changeVal).submit();

            targetForm.prop('action', defaultVal);

          } else {

            targetForm.prop('action', changeVal).prop("target", "_blank").submit();

            targetForm.prop('action', defaultVal).removeAttr("target");

          }

        });

      },

    

      dateCalendar() {

        flatpickr('.' + mod.targetDate, {

          dateFormat: 'Y-m-d',

          locale: 'ja',

          allowInput: true,

        });

    

        $('.' + mod.targetDateClear).each(function () {

          $(this).on('click', function () {

            $(this).prev().val('');

          });

        });

    

        flatpickr('.' + mod.targetDateFuture, {

          dateFormat: 'Y-m-d',

          locale: 'ja',

          allowInput: true,

          minDate: 'today',

        });

      },

    

      sortList() {

        let elm = document.getElementById(mod.targetSort);

        if (elm != null) {

          let sortable = Sortable.create(elm, {

            animation: 50

          });

    

          $('.' + mod.targetSortName).each(function () {

            $(this).on('change', function () {

              let blank_name = $(this).data('name'),

                target = $(this).data('sort'),

                value = $(this).val();

              if (value !== '') {

                $(target).text(value);

              } else {

                $(target).text(blank_name);

              }

            }).change();

          });

        }

      },

    

    }

    

    

    const DrawerMenu = {

    

      init() {

        drawer = {

          panel     : 'js-drawerPanel',

          menu      : 'js-drawerMenu',

          duration  : 10,

          // openclass : 'slideout-open',

          toggleList: '#js-drawerToggle',

          closeList : '#js-drawerPanel, #js-drawerMenu .js-scroll',

        };

    

        this.menu();

      },

    

      menu() {

        if ( document.getElementById(drawer.menu) != null ) {

          let slideoutInst = new Slideout({

            'panel': document.getElementById(drawer.panel),

            'menu': document.getElementById(drawer.menu),

            'duration': drawer.duration,

            // 'openclass': drawer.openclass,

          });

    

          let nodeList = document.querySelectorAll(drawer.toggleList);

          let node = Array.prototype.slice.call(nodeList,0);

          node.forEach(function(elem, index){

            elem.addEventListener('click', function() {

              slideoutInst.toggle();

            });

          });

    

          let nodeListClose = document.querySelectorAll(drawer.closeList);

          let nodeClose = Array.prototype.slice.call(nodeListClose,0);

          nodeClose.forEach(function(elem, index){

            elem.addEventListener('click', function() {

              slideoutInst.close();

            });

          });

        }

      },

    

    }

    

    

    

    const Wordpress = {

    

      init() {

        wp = {

          editorTarget: 'js-editor',

          tableClass  : 'c-tbl_responsive',

          iframeclass : 'c-iframe',

        };

    

        this.wpEditor();

      },

    

      wpEditor() {

        if ( document.getElementById(wp.editorTarget) != null ) {

          $( '#' + wp.editorTarget + ' table' ).each(function() {

            $(this).wrap('<div class="' + wp.tableClass + '"></div>');

          });

          $( '#' + wp.editorTarget + ' iframe' ).each(function() {

            $(this).wrap('<div class="' + wp.iframeclass + '"></div>');

          });

        }

        // if ( $('.' + wp.editorTarget).length ) {

        //   $( '.' + wp.editorTarget + ' table' ).each(function() {

        //     $(this).wrap('<div class="' + wp.tableClass + '"></div>');

        //   });

        //   $( '.' + wp.editorTarget + ' iframe' ).each(function() {

        //     $(this).wrap('<div class="' + wp.iframeclass + '"></div>');

        //   });

        // }

      }

    

    }

    

    

    

    const Slick = {

    

      init() {

        slider = {};

      },

    

      topKey() {

        $('#js-sldKey').slick({

          fade: true,

          autoplay: true,

          autoplaySpeed: 5000,

          speed: 1200,

          cssEase: 'linear',

          arrows: false,

          dots: false,

          swipe: false,

          pauseOnFocus: false,

          pauseOnHover: false,

        });

      },

    

      topRelation() {

        $('#js-sldRelation').slick({

          autoplay: true,

          autoplaySpeed: 5000,

          speed: 1200,

          slidesToShow: 3,

          arrows: true,

          prevArrow: '<button class="slick-prev-cus slick-arrow" aria-label="Previous" type="button"></button>',

          nextArrow: '<button class="slick-next-cus slick-arrow" aria-label="Next" type="button"></button>',

          dots: false,

          pauseOnFocus: false,

          pauseOnHover: false,

          responsive:[

            {

              breakpoint: 768,

              settings:{

                slidesToShow: 1,

                centerMode: true,

                centerPadding: '25%',

                // arrows: false,

                // dots: true,

              }

            },

            {

              breakpoint: 576,

              settings:{

                slidesToShow: 1,

                centerMode: true,

                centerPadding: '10%',

              }

            },

          ]

        });

      },

    

    }

    

    

    

    const GoogleMap = {

    

      init() {

        map = {

          zoom: 17,

          obj: '',

          marker: '',

          info: '',

          geocode: '',

          actList: document.querySelectorAll('.js-mapAct'),

          viewTag: document.getElementById('js-map'),

    

          latTag: document.getElementById('js-mapLat'),

          lngTag: document.getElementById('js-mapLng'),

          latLng: { lat: 0, lng: 0 },

    

          companyTag: document.getElementById('js-mapCompany'),

          addressTag: document.getElementById('js-mapAddress'),

          window: {

            company: '',

            address: '',

          },

    

          eventTag: document.getElementById('js-mapEvent'),

          event: false,

    

          zoomTag: document.getElementById('js-mapZoom'),

    

          geocodeApi: '',

          geocodeBtnTag: document.getElementById('js-mapGeocode'),

          geocodeWordTag: document.getElementById('js-mapGeocodeWord'),

        };

    

        if (map.latTag != null && map.lngTag != null) {

          map.latLng.lat = map.latTag.value - 0;

          map.latLng.lng = map.lngTag.value - 0;

        }

    

        if (map.companyTag != null && map.addressTag != null) {

          map.window.company = map.companyTag.value.replace(/</g, '&lt;').replace(/>/g, '&gt;');

          map.window.address = map.addressTag.value.replace(/</g, '&lt;').replace(/>/g, '&gt;');

        }

    

        if (map.eventTag != null && (map.eventTag.value - 0)) {

          map.event = true;

        }

    

        if (map.zoomTag != null) {

          map.zoom = map.zoomTag.value - 0;

        }

    

        this.actMap();

    

        if (map.geocodeBtnTag != null) {

          this.geocode();

        }

      },

    

      initMap() {

        let opts = {

          center: map.latLng,

          zoom: map.zoom,

        }

        map.obj = new google.maps.Map(map.viewTag, opts);

    

        this.marker();

    

        if (map.companyTag != null && map.addressTag != null && map.marker) {

          this.infoWindow();

        }

    

        if (map.event) {

          this.addEvent();

        }

      },

    

      marker() {

        map.marker = new google.maps.Marker({

          position: map.latLng,

          map: map.obj,

          draggable: map.event,

        });

      },

    

      infoWindow() {

        map.info = new google.maps.InfoWindow({

          content: '<div class="c-info"><p class="c-info__name">' + map.window.company + '</p><p class="c-info__address">' + map.window.address + '</p></div>',

        })

        map.info.open(map.obj, map.marker);

    

        map.marker.addListener('click', function () {

          map.info.open(map.obj, map.marker);

        });

      },

    

      addEvent() {

        map.obj.addListener('click', function (e) {

          map.latLng = e.latLng;

          map.latTag.value = map.latLng.lat();

          map.lngTag.value = map.latLng.lng();

    

          map.marker.setMap(null);

          GoogleMap.marker();

          GoogleMap.dragEvent();

        });

    

        google.maps.event.addListener(map.obj, 'zoom_changed', function () {

          map.zoom = map.obj.getZoom();

          map.zoomTag.value = map.zoom;

        });

    

        GoogleMap.dragEvent();

      },

    

      dragEvent() {

        map.marker.addListener('dragend', function (e) {

          map.latLng = e.latLng;

          map.latTag.value = map.latLng.lat();

          map.lngTag.value = map.latLng.lng();

        });

      },

    

      actMap() {

        for (let i = 0, num = map.actList.length; num > i; i++) {

          let elm = map.actList[i];

          if (elm.tagName === 'INPUT') {

            elm.addEventListener('change', function (e) {

              if (elm.checked && !elm.dataset.state) {

                elm.dataset.state = '1';

                GoogleMap.initMap();

              }

            });

            elm.dispatchEvent(new Event("change"));

          }

        }

    

        document.addEventListener('click', function (e) {

          if (e.target.classList.contains('js-mapAct') && e.target.tagName === 'BUTTON') {

            if (!e.target.dataset.state) {

              let dataMap = e.target.dataset.map;

              e.target.remove();

    

              if (dataMap) {

                map.viewTag = document.getElementById('js-map' + dataMap);

                map.latTag = document.getElementById('js-mapLat' + dataMap);

                map.lngTag = document.getElementById('js-mapLng' + dataMap);

                map.latLng.lat = map.latTag.value - 0;

                map.latLng.lng = map.lngTag.value - 0;

    

                map.companyTag = document.getElementById('js-mapCompany' + dataMap);

                map.addressTag = document.getElementById('js-mapAddress' + dataMap);

                map.window.company = map.companyTag.value.replace(/</g, '&lt;').replace(/>/g, '&gt;');

                map.window.address = map.addressTag.value.replace(/</g, '&lt;').replace(/>/g, '&gt;');

              }

    

              e.target.dataset.state = '1';

              map.viewTag.classList.remove('u-none');

              GoogleMap.initMap();

            }

          }

        });

    

        // $('.' + map.classAct).each(function () {

        //   if (this.tagName == 'INPUT') {

        //     $(this).on('change', function () {

        //       if (this.checked && !$(this).data('state')) {

        //         $(this).data('state', '1');

        //         GoogleMap.initMap();

        //       }

        //     }).change();

        //   } else if (this.tagName == 'BUTTON') {

        //     $(this).on('click', function () {

        //       if (!$(this).data('state')) {

        //         if ($(this).data('map')) {

        //           let dataMap = $(this).data('map');

        //           map.viewTag = document.getElementById('js-map' + dataMap);

        //           map.latTag = document.getElementById('js-mapLat' + dataMap);

        //           map.lngTag = document.getElementById('js-mapLng' + dataMap);

        //           map.latLng.lat = map.latTag.value - 0;

        //           map.latLng.lng = map.lngTag.value - 0;

    

        //           map.companyTag = document.getElementById('js-mapName' + dataMap);

        //           map.addressTag = document.getElementById('js-mapAddress' + dataMap);

        //           map.window.company = map.companyTag.value;

        //           map.window.address = map.addressTag.value;

        //         }

    

        //         $(this).data('state', '1');

        //         GoogleMap.initMap();

        //       }

        //     });

        //   }

        // });

      },

    

      geocode() {

        map.geocodeBtnTag.addEventListener('click', function (e) {

          let word = map.geocodeWordTag.value;

          if (word) {

            map.geocode = new google.maps.Geocoder();

            map.geocode.geocode({ address: word }, function (results, status) {

              if (status === 'OK' && results[0]) {

                let location = results[0].geometry.location;

                map.latLng = location;

                map.latTag.value = location.lat();

                map.lngTag.value = location.lng();

    

                GoogleMap.initMap();

              } else {

                alert('エラーが発生しました。ERROR: ' + status);

              }

            });

    

            // let request = new XMLHttpRequest(),

            //   url = 'https://maps.googleapis.com/maps/api/geocode/json?key=' + map.geocodeApi + '&language=ja&address=' + word;

    

            // request.open('GET', url);

            // request.send();

    

            // request.onloadend = function () {

            //   if (request.readyState === 4 && request.status === 200) {

            //     let $json = JSON.parse(request.response),

            //       location = $json.results[0].geometry.location;

    

            //     map.latLng = location;

            //     map.latTag.value = location.lat;

            //     map.lngTag.value = location.lng;

    

            //     GoogleMap.initMap();

            //   } else {

            //     alert('エラーが発生しました。再度お試しください');

            //   }

            // }

    

            // $.ajax({

            //   url: 'https://maps.googleapis.com/maps/api/geocode/json',

            //   type: 'GET',

            //   dataType: 'json',

            //   data: {

            //     key: map.geocodeApi,

            //     address: word,

            //     language: 'ja'

            //   }

            // }).done(function (data) {

            //   if (data.status == "OK") {

            //     let result = data.results[0];

            //     map.latLng = result.geometry.location;

            //     map.latTag.value = result.geometry.location.lat;

            //     map.lngTag.value = result.geometry.location.lng;

            //     GoogleMap.initMap();

            //   } else {

            //     alert('エラーが発生しました。再度お試しください');

            //   }

            // });

          }

        });

      }

    

    }

    

    

    const Ajax = {

      init() {

        ajax = {

          postUrl: "/wp/wp-content/themes/allmanage_theme/inc/config/system_ajax.php",

          postNonce: "js-ajaxNonce",

    

          autoComplete: "js-autoComplete",

          memberGroupIds: "js-memberGroupIds",

          memberGroupWrap: "js-memberGroupWrap",

          memberGroupDelete: "js-memberGroupDelete",

    

          attendanceYear: 2023,

          attendanceLabelImg: "/assets/img/common/panel_rabby_01.jpg",

          membersSearchBtn: "js-membersSearch",

          membersSearchNext: "js-membersSearchNext",

          membersList: "js-searchList",

          membersLoader: "js-searchLoader",

          searchCompany: "js-searchCompany",

          searchLicense: "js-searchLicense",

          searchName: "js-searchName",

          searchInitial: "js-searchInitial",

          searchRent: "js-searchRent",

          searchBuy: "js-searchBuy",

          searchAddress: "js-searchAddress",

          searchTel: "js-searchTel",

          searchOrganization: "js-searchOrganization",

        };

    

        if (website.page == "admin") {

          this.autoComplete();

        } else if (website.page == "search") {

          this.membersSearchTrigger();

        }

      },

    

      autoComplete() {

        if (document.getElementById(ajax.autoComplete) != null) {

          $("#" + ajax.autoComplete).autocomplete({

            source: function (request, response) {

              $.ajax({

                url: ajax.postUrl,

                dataType: "json",

                type: "POST",

                cache: false,

                dataFilter: function (data, type) {

                  data = data.replace(/</g, "&lt;").replace(/>/g, "&gt;");

                  return data;

                },

                data: {

                  nonce: $("#" + ajax.postNonce).val(),

                  type: "group",

                  ids: $("#" + ajax.memberGroupIds).val(),

                  text: request.term,

                },

                success: function (data) {

                  response(data);

                },

                error: function (XMLHttpRequest, textStatus, errorThrown) {

                  response([""]);

                },

              });

            },

            select: function (event, ui) {

              let id = ui.item.value,

                user_login = ui.item.user_login,

                company = ui.item.company,

                name = ui.item.name,

                wrap =

                '<div class="btn border text-start bg-light w-16 m-1 c-btn_nav"><div class="c-btn_nav__wrap"><a href="/wp/wp-admin/admin.php?page=members&action=detail&id=' +

                id +

                '" target="_blank" class="btn p-1 opacity-75-hover fs-6 text-primary"><i class="bi bi-info-circle-fill"></i></a><button type="button" data-id="' +

                id +

                '" class="btn p-1 opacity-75-hover fs-6 text-danger js-memberGroupDelete"><i class="bi bi-x-circle-fill"></i></button></div><p class="mb-0 text-secondary">統一コード</p><p class="mb-0">' +

                user_login +

                '</p><p class="mb-0 text-secondary">会社名</p><p class="mb-0 text-truncate">' +

                company +

                '</p><p class="mb-0 text-secondary">代表者名</p><p class="mb-0 text-truncate">' +

                name +

                "</p></div>",

                ids = $("#" + ajax.memberGroupIds).val();

    

              if (ids == "") {

                array = [];

              } else {

                array = ids.split(",");

              }

    

              $("#" + ajax.autoComplete).val("");

              array.push(id);

              string = array.join(",");

              $("#" + ajax.memberGroupIds).val(string);

              $("#" + ajax.memberGroupWrap).append(wrap);

            },

            close: function (event, ui) {

              $("#" + ajax.autoComplete).val("");

            },

          });

    

          $(document).on("click", "." + ajax.memberGroupDelete, function () {

            let delete_id = String($(this).data("id")),

              ids = $("#" + ajax.memberGroupIds).val(),

              array = ids.split(","),

              index = array.indexOf(delete_id);

    

            if (index >= 0) {

              array.splice(index, 1);

            }

    

            string = array.join(",");

            $("#" + ajax.memberGroupIds).val(string);

    

            $(this).parents(".c-btn_nav").remove();

          });

        } else if (document.getElementsByClassName(ajax.autoComplete).length) {

          $("." + ajax.autoComplete).autocomplete({

            source: function (request, response) {

              $.ajax({

                url: ajax.postUrl,

                dataType: "json",

                type: "POST",

                cache: false,

                dataFilter: function (data, type) {

                  data = data.replace(/</g, "&lt;").replace(/>/g, "&gt;");

                  return data;

                },

                data: {

                  nonce: $("#" + ajax.postNonce).val(),

                  type: "form",

                  text: request.term,

                },

                success: function (data) {

                  response(data);

                },

                error: function (XMLHttpRequest, textStatus, errorThrown) {

                  response([""]);

                },

              });

            },

            close: function (event, ui) {

              if (isNaN($(event.target).val())) {

                $(event.target).val("");

              }

            },

          });

        }

      },

    

      membersSearchTrigger() {

        $(document).on("click", "#" + ajax.membersSearchBtn, function () {

          $("#" + ajax.membersList).empty();

          $("#" + ajax.membersSearchNext).val("1");

          Ajax.membersSearchAjax("first");

        });

        $(document).on("click", "#" + ajax.membersSearchNext, function () {

          Ajax.membersSearchAjax("");

        });

      },

    

      membersSearchAjax(type) {

        $("#" + ajax.membersLoader).fadeIn("fast");

        $.ajax({

          url: ajax.postUrl,

          dataType: "json",

          type: "POST",

          cache: false,

          dataFilter: function (data, type) {

            data = data.replace(/</g, "&lt;").replace(/>/g, "&gt;");

            return data;

          },

          data: {

            nonce: $("#" + ajax.postNonce).val(),

            type: "member",

            next: $("#" + ajax.membersSearchNext).val(),

            company: $("#" + ajax.searchCompany).val(),

            license: $("#" + ajax.searchLicense).val(),

            name: $("#" + ajax.searchName).val(),

            initial: $("#" + ajax.searchInitial).val(),

            rent: $("#" + ajax.searchRent).val(),

            buy: $("#" + ajax.searchBuy).val(),

            address: $("#" + ajax.searchAddress).val(),

            tel: $("#" + ajax.searchTel).val(),

            organization: $("#" + ajax.searchOrganization).val(),

          },

          success: function (data) {

            $("#" + ajax.membersLoader).hide();

            if (type === "first") {

              Ajax.membersSearchTitle(data.count);

              if (data.next > 0) {

                $("#" + ajax.membersSearchNext).removeClass("u-none");

              }

            }

            Ajax.membersSearchHtml(data.members);

            if (data.next > 0) {

              $("#" + ajax.membersSearchNext).val(data.next);

            } else {

              $("#" + ajax.membersSearchNext).addClass("u-none");

            }

          },

          error: function (XMLHttpRequest, textStatus, errorThrown) {

            $("#" + ajax.membersLoader).hide();

            Ajax.membersSearchError();

          },

        });

      },

    

      membersSearchError() {

        $("#" + ajax.membersList).html(

          '<p class="u-center">エラーが発生しました。再度やり直してください。</p>'

        );

      },

    

      membersSearchTitle(count) {

        if (count > 0) {

          $("#" + ajax.membersList).prepend(

            '<h3 class="c-ttl_strong">' +

            count +

            ' 件 <span class="u-fs">がヒットしました</span></h3>'

          );

        } else {

          $("#" + ajax.membersList).prepend(

            '<h3 class="c-ttl_strong">ご指定の検索条件ではヒットしませんでした。</h3>'

          );

        }

      },

    

      membersSearchHtml(members) {

        let currentTime = new Date(),

          currentYear = currentTime.getFullYear();

    

        for (const member of members) {

          let url = "",

            rent = "",

            buy = "",

            html = "",

            color = "",

            count,

            attendanceYears = [],

            attendanceTr = "",

            attendanceLabels = "";

    

          if (document.URL.match("branch")) {

            color = "-branch";

          }

    

          if (member.url != "") {

            url =

              '<tr><th>URL</th><td colspan="3"><a href="' +

              member.url +

              '" class="c-anc">' +

              member.url +

              "</a></td></tr>";

          }

          for (let value of member.business_buy) {

            buy +=

              '<li class="c-list_horizon__item"><span class="c-label ' +

              color +

              '">' +

              value +

              "</span></li>";

          }

          for (let value of member.business_rent) {

            rent +=

              '<li class="c-list_horizon__item"><span class="c-label -c_dgreen">' +

              value +

              "</span></li>";

          }

    

          for (key in member.attendance) {

            if (

              ajax.attendanceYear <= currentYear &&

              ajax.attendanceYear - 1 <= key

            ) {

              count = 0;

              if (member.attendance.hasOwnProperty(key)) {

                for (let value of member.attendance[key]) {

                  if (value === "出席") {

                    count++;

                  }

                }

              }

              if (count >= 3) {

                attendanceYears.push(key);

              }

            }

    

          }

    

          if (attendanceYears.length) {

            for (let year of attendanceYears) {

              attendanceLabels +=

                '<div class="c-list_panel__item"><div class="c-list_panel__imgWrap"><img src="' +

                ajax.attendanceLabelImg +

                '" width="230" height="140" alt="" class="c-img"><p class="c-list_panel__overWrap"><span class="c-list_panel__textSup">' +

                year +

                '年度</span><span class="c-list_panel__text">研修済</span></p></div></div>';

            }

    

            attendanceTr =

              '<tr><th>法定研修会</th><td colspan="3"><div class="c-list_panel -in_table">' +

              attendanceLabels +

              "</div></td></tr>";

          }

    

          html =

            '<div class="c-box_bdt">' +

            '  <p class="c-ttl_strong">' +

            member.company + (member.branch ? " " + member.branch : "") +

            "</p>" +

            '  <div class="u-of_hidden">' +

            '    <table class="c-tbl -th_bg -search -bd_negative ' +

            color +

            '">' +

            "      <tbody>" +

            "        <tr>" +

            "          <th>代表者名</th>" +

            '          <td colspan="3">' +

            member.name +

            "</td>" +

            "        </tr>" +

            "        <tr>" +

            "          <th>住所</th>" +

            '          <td colspan="3">〒 ' +

            member.zipcode +

            " <br> " +

            member.address_1 +

            " " +

            member.address_2 +

            "</td>" +

            "        </tr>" +

            "      " +

            url +

            "        <tr>" +

            "          <th>電話番号</th>" +

            "          <td>" +

            member.tel +

            "</td>" +

            "          <th>FAX番号</th>" +

            "          <td>" +

            member.fax +

            "</td>" +

            "        </tr>" +

            "        <tr>" +

            "          <th>免許番号</th>" +

            "          <td>" +

            member.license +

            "</td>" +

            "          <th>所属支部</th>" +

            "          <td>" +

            member.organization +

            "</td>" +

            "        </tr>" +

            "        <tr>" +

            "          <th>取扱業務</th>" +

            '          <td colspan="3">' +

            '            <ul class="c-list_horizon">' +

            buy +

            rent +

            "</ul>" +

            "          </td>" +

            "        </tr>" +

            "      " +

            attendanceTr +

            "      </tbody>" +

            "    </table>" +

            "  </div>" +

            '  <div class="u-mgt_lg">' +

            '    <button type="button" class="c-btn -arrow_b ' +

            color +

            ' js-mapAct" data-map="' +

            member.id +

            '">地図を表示</button>' +

            '    <input type="hidden" name="form_map_lat" value="' +

            member.map_lat +

            '" id="js-mapLat' +

            member.id +

            '">' +

            '    <input type="hidden" name="form_map_lng" value="' +

            member.map_lng +

            '" id="js-mapLng' +

            member.id +

            '">' +

            '    <input type="hidden" name="form_map_company" value="' +

            member.company +

            '" id="js-mapCompany' +

            member.id +

            '">' +

            '    <input type="hidden" name="form_map_address" value="' +

            member.address_1 +

            " " +

            member.address_2 +

            '" id="js-mapAddress' +

            member.id +

            '">' +

            '    <input type="hidden" name="form_map_zoom" value="17" id="js-mapZoom' +

            member.id +

            '">' +

            '    <div class="c-iframe u-none" id="js-map' +

            member.id +

            '"></div>' +

            "  </div>" +

            "</div>";

    

          $("#" + ajax.membersList).append(html);

        }

      },

    };


    // OFF
    
    const Animation = {
    
      init() {
        anime = {
          // loader: 'js-loader',
          // time: (website.page == 'top') ? 200: 200,
          word: 'js-animeWord',
        };
    
        this.word();
      },
    
      check() {
        $('.' + website.targetAnime + ':not(.' + website.actAnime + ')').each(function(){
          let self = $(this),
              targetPosition = self.offset().top,
              triggerPosition,
              shift;
    
          if( website.winWidth < website.shiftPoint ) {
            shift = website.winHeight / website.shiftSp;
          } else {
            shift = website.winHeight / website.shiftPc;
          }
          triggerPosition = targetPosition - website.winHeight + shift;
    
          if( website.scrollY > triggerPosition ){
            self.addClass(website.actAnime);
          }
        });
      },
    
      // loader() {
      //   if ( website.page == 'top' ) {
      //     // document.getElementById(anime.loader).classList.add(website.act);
    
      //     setTimeout( function() {
      //       document.scrollingElement.scrollTop = 0;
      //     }, 100 );
      //   } else if ( location.hash != "" && location.hash != "#" ) {
      //     setTimeout( function() {
      //       let shift    = ( website.winWidth < website.shiftPoint ) ? website.headTag.offsetHeight: 0,
      //           position = $(location.hash).offset().top - shift;
      //       $('body, html').animate({scrollTop: position}, mod.smoothSpeed, 'swing');
      //     }, 100 );
      //   }
    
      //   setTimeout( function() {
      //     if ( website.page == 'top' ) {
      //       // Top.init();
      //     }
    
      //     if ( website.isDesktop ) {
      //       // Modules.cursor();
      //     }
    
      //     document.body.classList.add(website.loaded);
      //     PageScroll.observer();
      //   }, anime.time );
      // },
    
      word() {
        let wordList    = document.querySelectorAll('.' + anime.word),
            targetsWord = Array.prototype.slice.call(wordList, 0),
            delayHead   = 0;
        targetsWord.forEach((target) => {
          let text  = target.innerHTML,
              html  = '',
              delay = 2000;
    
          text.split(' ').forEach(function (w) {
            if ( w == '<br>' ) {
              html  += w;
              delay -= 100;
            } else if ( w == '&nbsp;' ) {
              html  += w;
            } else {
              html += '<span><span style="transition-delay: ' + delay + 'ms;">' + w + '</span></span>';
            }
            delay += 50;
          });
          target.innerHTML = html;
        });
      },
    
    }
    
    

    // ./inc/_pagescroll.js

    // ./inc/_parallax.js



    const BasicPage = {

      init() {
        basic = {
          targetFloat: document.getElementById('js-floatNav'),
          targetFloatClose: document.getElementById('js-floatNavClose'),

          targetCookie: document.getElementById('js-setCookie'),
        };

        this.setCookie();
      },

      headFix() {
        if (website.scrollY < website.scrollCurrent || website.scrollY <= 10 || website.scrollCurrent == 0) {
          website.headTag.classList.add('is-view');
        } else if (website.scrollY > website.scrollCurrent) {
          website.headTag.classList.remove('is-view');
        }

        website.scrollCurrent = website.scrollY;
      },

      floatNav() {
        if (basic.targetFloat != null) {
          basic.targetFloat.classList.add('is-view');

          basic.targetFloatClose.addEventListener('click', function () {
            basic.targetFloat.remove();
            document.cookie = "float_bnr=close;path=/"
          });
        }
      },

      setCookie() {
        if (basic.targetCookie != null) {
          let cookie = basic.targetCookie.dataset.cookie;
          document.cookie = cookie + "=1;path=/"
        }
      },

      update() {
      },

    }


    const TopPage = {

      init() {
        top = {};

        Slick.topKey();
        Slick.topRelation();
      },

      update() {
      },

    }



    const App = {

      init() {
        if (website.page != 'wp-manual' && website.page != 'wp-manual-single') {
          this.set();
          // this.update();
        } else {
          // Modules.init();
          Wordpress.init();
        }
      },

      set() {
        Modules.init();
        Animation.init();
        // PageScroll.init();
        // Parallax.init();
        DrawerMenu.init();
        Wordpress.init();
        Slick.init();
        BasicPage.init();
        GoogleMap.init();
        Ajax.init();


        if (website.page == 'top') {
          TopPage.init();
        }

        if (website.page != 'admin') {
          WinLoad.add(Modules.viewportHeight);
          WinLoad.add(Animation.check);
          // WinLoad.add( Modules.alignHeight );
          WinLoad.add(BasicPage.floatNav);

          WinResize.add(Modules.iosCheck);
          WinResize.add(Modules.deviceCheck);

          WinResizeWidth.add(Modules.viewportHeight);
          // WinResizeWidth.add( Modules.alignHeight );

          WinScroll.add(Animation.check);
          WinScroll.add(BasicPage.headFix);

          // OrientationChange.add( xxx );
        }


        WinLoad.init();
        WinResize.init();
        WinResizeWidth.init();
        WinScroll.init();
        OrientationChange.init();

      },

      update() {
        //   website.animationFrame = window.requestAnimationFrame( App.update );
        //   website.winWidth       = window.innerWidth;
        //   website.winHeight      = window.innerHeight;
        //   website.scrollY        = window.pageYOffset;

        //   if ( website.isDesktop ) {
        //     PageScroll.smooth();

        //     if ( website.page == 'top' ) {
        //       Parallax.moveImg();
        //     }
        //   }
      },

    }


    App.init();

  })();


})(jQuery);
